import { useToast } from '@color/continuum';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { useAddVariantMutation } from '../../apis';
import { IAddVariantPayload } from '../../types';

import { FormDialog } from './components/FormDialog';

interface Props {
  onDismiss: () => void;
  dialogIsOpen: boolean;
}

export const AddVariantDialog: React.FC<Props> = (props) => {
  const { onDismiss, dialogIsOpen } = props;
  const { mutateAsync: addVariant } = useAddVariantMutation();
  const { showErrorToast } = useToast();

  return (
    <Formik<IAddVariantPayload>
      initialValues={{
        chrom: '',
        pos: 0,
        ref: '',
        alt: '',
        tag: '',
      }}
      validationSchema={Yup.object().shape({
        chrom: Yup.string().required(),
        pos: Yup.number().required(),
        ref: Yup.string().required(),
        alt: Yup.string().required(),
        tag: Yup.string(),
      })}
      onSubmit={async (values, { resetForm }) => {
        try {
          await addVariant(values);
          resetForm();
          onDismiss();
        } catch {
          showErrorToast('Variant annotation failed.');
        }
      }}
    >
      <FormDialog dialogIsOpen={dialogIsOpen} onDismiss={onDismiss} />
    </Formik>
  );
};
